export default __webpack_public_path__ + "static/media/verifed.d0024e82.png";